/* ============================================
   DRIFT Theme by WEBEXP, LLC
   DRIFT Feed — Scroll Transitions + Rubber Band Loop
   https://webexp.dev
   ============================================ */

(function () {
  /* FEATURE-002: dual-render section.
     - section = outer wrapper with data-section-type="drift-feed"
     - feedEl  = swipe view block (.drift-feed)
     - gridEl  = grid view block (.drift-collection__grid-wrap)
     One has the `hidden` attribute on initial render based on the
     merchant's Default view setting; localStorage can override. */
  var section = document.querySelector('[data-section-type="drift-feed"]');
  if (!section) return;
  /* BUG: drift-collection.liquid loads drift-feed.js to handle its own
     swipe transforms. Collection's feed block IS the [data-section-type]
     element (no inner [data-feed-view="swipe"] child), so fall back to
     `section` itself when the inner block is absent. This keeps Collection's
     feed view working while the new dual-render Product Feed structure
     still gets its inner swipe block. */
  var feed = section.querySelector('[data-feed-view="swipe"]') || section;
  var gridEl = section.querySelector('[data-feed-view="grid"]');

  var allowToggle = section.getAttribute('data-allow-toggle') === 'true';
  var defaultView = section.getAttribute('data-default-view') || 'swipe';
  var savedView = null;
  try { savedView = localStorage.getItem('drift-feed-view'); } catch (e) {}
  var initialView = (allowToggle && gridEl && (savedView === 'swipe' || savedView === 'grid'))
    ? savedView
    : defaultView;
  if (initialView !== defaultView) {
    if (initialView === 'grid' && gridEl) {
      feed.hidden = true;
      gridEl.hidden = false;
    } else if (initialView === 'swipe') {
      feed.hidden = false;
      if (gridEl) gridEl.hidden = true;
    }
  }
  section.setAttribute('data-view-mode', initialView);
  document.documentElement.setAttribute('data-view-mode', initialView);

  var track = feed.querySelector('[data-feed-track]');
  if (!track) return;
  var slides = track.querySelectorAll('[data-feed-slide]');
  if (slides.length === 0) return;

  var SCALE_MIN = 0.7;
  var SCALE_MAX = 1;
  var BLUR_MAX = 6;
  var OPACITY_MIN = 0.3;

  var spacerTop = track.querySelector('[data-feed-spacer="top"]');
  var spacerBottom = track.querySelector('[data-feed-spacer="bottom"]');
  var currentIndex = -1;
  var isLooping = false;
  var counterEl = feed.querySelector('[data-feed-current]');
  var dots = feed.querySelectorAll('[data-feed-dot]');

  var params = new URLSearchParams(window.location.search);
  var resumeIndex = params.has('feed_index') ? parseInt(params.get('feed_index'), 10) : -1;
  var hasResume = resumeIndex >= 0 && resumeIndex < slides.length;

  /* FEATURE: per-product background color morph (Studio only).
     Gated by the [data-bg-morph="true"] attribute on the .drift-feed wrapper —
     so this only activates on the Product Feed section, not the Collection's
     swipe view, even though both use this script. */
  var bgMorphEnabled = feed.getAttribute('data-bg-morph') === 'true';

  function setPadding() {
    var trackH = track.offsetHeight;
    var slideH = slides[0] ? slides[0].offsetHeight : 0;
    var pad = Math.max((trackH - slideH) / 2, 0);
    if (spacerTop) spacerTop.style.height = pad + 'px';
    if (spacerBottom) spacerBottom.style.height = pad + 'px';
  }

  /* Parse a hex color (#RGB or #RRGGBB) into {r,g,b} 0–255.
     Returns null for invalid input so callers can fall back gracefully. */
  function parseHexColor(hex) {
    if (!hex) return null;
    hex = hex.trim().replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6 || /[^0-9a-f]/i.test(hex)) return null;
    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16)
    };
  }

  /* Relative luminance of an RGB color (0–1). Used to pick black or white
     text against any background for guaranteed contrast. */
  function relativeLuminance(rgb) {
    var srgb = [rgb.r, rgb.g, rgb.b].map(function (c) {
      c = c / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
  }

  /* Hex → HSL conversion. Returns {h:0-360, s:0-100, l:0-100}. */
  function rgbToHsl(rgb) {
    var r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = 0, s = 0, l = (max + min) / 2;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h *= 60;
    }
    return { h: h, s: s * 100, l: l * 100 };
  }

  /* HSL → hex. h in 0-360, s/l in 0-100. */
  function hslToHex(h, s, l) {
    h = ((h % 360) + 360) % 360;
    s = Math.max(0, Math.min(100, s)) / 100;
    l = Math.max(0, Math.min(100, l)) / 100;
    var c = (1 - Math.abs(2 * l - 1)) * s;
    var x = c * (1 - Math.abs((h / 60) % 2 - 1));
    var m = l - c / 2;
    var r = 0, g = 0, b = 0;
    if (h < 60)      { r = c; g = x; b = 0; }
    else if (h < 120){ r = x; g = c; b = 0; }
    else if (h < 180){ r = 0; g = c; b = x; }
    else if (h < 240){ r = 0; g = x; b = c; }
    else if (h < 300){ r = x; g = 0; b = c; }
    else             { r = c; g = 0; b = x; }
    var toHex = function (v) {
      var n = Math.round((v + m) * 255).toString(16);
      return n.length === 1 ? '0' + n : n;
    };
    return '#' + toHex(r) + toHex(g) + toHex(b);
  }

  /* Derive a 4-color palette from a single seed hex.
     Tactic: ensure dramatic LIGHTNESS variation so the mesh has visible
     bright + dark areas. Same hue family but spread across the lightness
     scale, with one analogous color added for hue variety. */
  function derivePalette(seedHex) {
    var rgb = parseHexColor(seedHex);
    if (!rgb) return null;
    var hsl = rgbToHsl(rgb);
    var h = hsl.h;
    var s = hsl.s;
    var l = hsl.l;

    /* Grayscale seed (pure white, pure black, or any near-gray) keeps a true
       grayscale palette — just spread across lightness. Pure black → dark
       grays. Pure white → light grays. No hue injection. */
    if (s < 8) {
      return [
        /* Kept deliberately close together — see the note on the colour
           branch below. */
        hslToHex(0, 0, Math.min(96, Math.max(20, l + 20))),
        hslToHex(0, 0, l + 2),
        hslToHex(0, 0, Math.min(88, Math.max(8, l - 9))),
        hslToHex(0, 0, Math.min(75, Math.max(4, l - 20)))
      ];
    }

    /* Colored seed: hue family palette with dramatic lightness spread. */
    s = Math.max(25, s);
    /* Tightened blend (v3.30.1) — must stay identical to the copy in
       drift-bg-init.js, or the feed and the site background would derive
       different palettes from the same seed and visibly disagree.
       The anchors used to span 60 points of lightness with a 35 degree hue
       rotation, which read as hard colour blocks and meant a merchant who
       set one hex in feed_bg_color saw four colours, none of them quite the
       one they picked. */
    return [
      hslToHex(h, Math.max(15, s - 4), Math.min(94, l + 20)),
      hslToHex(h, s, l + 2),
      hslToHex((h + 26) % 360, Math.min(95, s + 6), Math.max(20, l - 7)),
      hslToHex(h, Math.min(95, s + 5), Math.max(8, l - 20))
    ];
  }

  /* Apply the active slide's bg color (and auto-inverted text color) to the
     .drift-feed wrapper via CSS custom properties. Clear when no color is set
     so the theme default takes over via the CSS fallback.
     If the slide also has media, skip this — the media will cover the color
     anyway, and applying the color immediately causes a brief flash before
     the media finishes loading. The media's loaded-callback will trigger
     this function again so the underlying color is correct once media fades in. */
  function applyBgColor(slide, force) {
    if (!bgMorphEnabled) return;
    var hasMedia = slide && slide.getAttribute('data-feed-bg-media-url');
    if (hasMedia && !force) return;
    var color = slide && slide.getAttribute('data-feed-bg-color');
    if (!color) {
      feed.style.removeProperty('--drift-feed-bg-active');
      feed.style.removeProperty('--drift-feed-bg-text');
      return;
    }
    feed.style.setProperty('--drift-feed-bg-active', color);
    var rgb = parseHexColor(color);
    if (rgb) {
      var textColor = relativeLuminance(rgb) > 0.5 ? '#0a0a0a' : '#f5f5f7';
      feed.style.setProperty('--drift-feed-bg-text', textColor);
    } else {
      feed.style.removeProperty('--drift-feed-bg-text');
    }
  }

  /* Apply the breathing gradient palette for the active slide.
     Seed color priority: product metafield → section default for current
     mode → theme default. Derive 4-color palette via HSL math, push to the
     WebGL shader. Shader handles smooth uniform interpolation on its own
     (600ms easeOutQuad) so we just call setColors with the new palette. */
  var shaderReady = false;
  var shaderLoading = false;

  function ensureShaderLoaded(canvas, initialPalette, onReady) {
    if (shaderReady && window.driftBgShader) {
      onReady();
      return;
    }
    if (shaderLoading) return;
    shaderLoading = true;
    var s = document.createElement('script');
    /* Asset URL is set on the .drift-feed wrapper by the Liquid via data attr. */
    s.src = feed.getAttribute('data-bg-shader-src');
    s.onload = function () {
      shaderLoading = false;
      if (window.driftBgShader && window.driftBgShader.init(canvas, initialPalette)) {
        shaderReady = true;
        onReady();
      }
    };
    s.onerror = function () {
      shaderLoading = false;
      console.warn('drift-feed: bg shader failed to load');
    };
    document.head.appendChild(s);
  }

  /* The site-wide gradient (rendered by drift-background.liquid when the
     theme setting is enabled) exposes window.driftSiteBg. When the merchant
     turns on 'Enable background morph' in the Product Feed section AND a
     product has a feed_bg_color metafield, we push that product's derived
     palette to the site-wide shader. Active slide changes call this — when
     the slide has no metafield, we reset to theme defaults. */
  /* If drift-bg-init.js loads AFTER us, the very first applyBgGradient call
     fires before window.driftSiteBg exists — palette gets silently dropped.
     drift-bg-init.js dispatches 'driftSiteBg:ready' once the API is live;
     when that fires we re-apply the current slide's palette. */
  function reapplyCurrentBgGradient() {
    if (currentIndex >= 0 && slides[currentIndex]) {
      applyBgGradient(slides[currentIndex]);
    }
  }
  /* Once the Enter Page overlay dismisses, re-apply the current slide's
     bg gradient so the metafield palette takes effect. */
  document.addEventListener('drift:enter-dismissed', reapplyCurrentBgGradient);
  /* Sync-check first because if drift-bg-init.js ran before drift-feed.js
     (defer scripts in DOM order), the ready event already fired and any
     addEventListener call now would never trigger. */
  if (window.driftSiteBg) {
    reapplyCurrentBgGradient();
  } else {
    document.addEventListener('driftSiteBg:ready', reapplyCurrentBgGradient, { once: true });
  }

  function applyBgGradient(slide) {
    if (!bgMorphEnabled) return;
    if (!window.driftSiteBg) return; /* site-wide gradient isn't enabled (yet) */

    /* Don't push per-product palette while the Enter Page overlay is visible.
       Its Live Gradient bg mode is transparent, so any tint applied to the
       site shader bleeds through the overlay and looks wrong. Enter Page
       dispatches 'drift:enter-dismissed' when it's gone, and we re-run
       this function then. */
    var enterPageEl = document.querySelector('[data-enter-page]');
    if (enterPageEl && enterPageEl.getAttribute('data-state') !== 'dismissing') {
      window.driftSiteBg.reset();
      return;
    }

    /* Grid view always shows the neutral theme gradient (light/dark mode
       seed) — per-product metafield palettes only apply to the swipe view. */
    if (section.getAttribute('data-view-mode') === 'grid') {
      window.driftSiteBg.reset();
      return;
    }

    /* If the active slide has media, the media overlay covers the gradient
       — skip pushing a new palette. Media's own layer handles the bg. */
    var hasMedia = slide && slide.getAttribute('data-feed-bg-media-url');
    if (hasMedia) return;

    /* Per-product seed if metafield set, otherwise revert to theme defaults
       (which adapt to light/dark mode automatically). */
    var seed = slide && slide.getAttribute('data-feed-bg-color');
    if (!seed) {
      window.driftSiteBg.reset();
      return;
    }
    var palette = derivePalette(seed);
    if (!palette) return;

    /* Auto-invert text color against seed luminance. */
    var rgb = parseHexColor(seed);
    if (rgb) {
      var text = relativeLuminance(rgb) > 0.5 ? '#0a0a0a' : '#f5f5f7';
      feed.style.setProperty('--drift-feed-bg-text', text);
    }

    window.driftSiteBg.override(palette);
  }

  /* Two-slot bg media crossfade architecture.
     We render TWO video elements and TWO image elements in the bg-layer.
     When the active slide changes, we load the new media into the INACTIVE
     slot. Once loaded, we add .is-active to the new slot and remove it from
     the previous one — both transitions run simultaneously, producing a
     smooth crossfade even between same-type media (video→video, image→image).
     A blank-frame "flash" between fades is impossible because the previous
     media stays visible until the new one is ready. */
  var bgState = { active: null }; // { el, type } of the currently-showing slot

  function getInactiveSlot(type) {
    if (!bgMorphEnabled) return null;
    var layer = feed.querySelector('[data-bg-layer]');
    if (!layer) return null;
    var slotA = type === 'video'
      ? layer.querySelector('[data-bg-slot="a"]')
      : layer.querySelector('[data-bg-slot="a-img"]');
    var slotB = type === 'video'
      ? layer.querySelector('[data-bg-slot="b"]')
      : layer.querySelector('[data-bg-slot="b-img"]');
    if (!slotA || !slotB) return null;
    /* If current active is slotA, return slotB (and vice versa). If neither
       is currently active, default to A. */
    if (bgState.active && bgState.active.el === slotA) return slotB;
    return slotA;
  }

  function deactivateCurrent(delayed) {
    if (!bgState.active) return;
    var el = bgState.active.el;
    var type = bgState.active.type;
    el.classList.remove('is-active');
    /* Pause + clear src after the fade-out completes so we stop downloading.
       650ms gives the 0.6s CSS transition a small buffer. */
    setTimeout(function () {
      if (el.classList.contains('is-active')) return; /* re-activated */
      if (type === 'video') {
        try { el.pause(); } catch (_) {}
        el.removeAttribute('src');
        try { el.load(); } catch (_) {}
      } else {
        el.removeAttribute('src');
      }
    }, 650);
    bgState.active = null;
  }

  /* Apply the active slide's bg media via the two-slot crossfade.
     If the slide has no media, fade the current slot out (revealing the
     bg color underneath). If it has media, load into the inactive slot,
     wait for it to be ready, then crossfade. */
  function applyBgMedia(slide) {
    if (!bgMorphEnabled) return;
    var url = slide && slide.getAttribute('data-feed-bg-media-url');
    var type = slide && slide.getAttribute('data-feed-bg-media-type');

    if (!url) {
      deactivateCurrent();
      /* Apply this slide's color (or theme default) as the underlying bg.
         Pass force=true so applyBgColor runs even if hasMedia was set
         elsewhere — here it isn't, but explicit is safer. */
      applyBgColor(slide, true);
      return;
    }

    var nextEl = getInactiveSlot(type);
    if (!nextEl) return;

    var reveal = function () {
      /* Fade the previous slot out (if any) and the new slot in. CSS handles
         both opacity transitions; they run simultaneously = smooth crossfade. */
      var prev = bgState.active;
      bgState.active = { el: nextEl, type: type };
      nextEl.classList.add('is-active');
      if (prev) {
        prev.el.classList.remove('is-active');
        setTimeout(function () {
          if (prev.el.classList.contains('is-active')) return;
          if (prev.type === 'video') {
            try { prev.el.pause(); } catch (_) {}
            prev.el.removeAttribute('src');
            try { prev.el.load(); } catch (_) {}
          } else {
            prev.el.removeAttribute('src');
          }
        }, 650);
      }
      /* Now that the new media is showing, sync the underlying color too — so
         when we eventually swipe to a no-media slide, the color underneath
         is correct (matches the new slide's metafield). */
      applyBgColor(slide, true);
      if (type === 'video') {
        var p = nextEl.play();
        if (p && p.catch) p.catch(function () {});
      }
    };

    if (nextEl.getAttribute('src') === url) {
      /* Same media already loaded in this slot — just reveal it. */
      reveal();
      return;
    }

    /* Load and wait. Removing any stale listener prevents double-fires if
       the user swipes rapidly across multiple slides. */
    var evt = type === 'video' ? 'loadeddata' : 'load';
    if (nextEl._driftReveal) nextEl.removeEventListener(evt, nextEl._driftReveal);
    nextEl._driftReveal = reveal;
    nextEl.addEventListener(evt, reveal, { once: true });
    nextEl.src = url;
    if (type === 'video') {
      try { nextEl.load(); } catch (_) {}
    }
  }

  /* Re-apply the gradient when the user switches modes — products without a
     metafield seed pull from a different section default per mode, so the
     palette needs to morph to match. */
  if (bgMorphEnabled && feed.getAttribute('data-bg-style') === 'gradient') {
    var modeObserver = new MutationObserver(function () {
      if (currentIndex >= 0) applyBgGradient(slides[currentIndex]);
    });
    modeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-drift-mode']
    });
  }

  /* Badge portal: the in-slide badge stack can't render above the scroll
     track's overflow clip, so it always sits tight against the media box.
     To match the PDP's spacing, the active slide's badges are CLONED into
     a body-level fixed wrapper anchored like the PDP badge (110px from
     viewport top). In-slide stacks are hidden via CSS. */
  var badgePortal = null;
  function ensureBadgePortal() {
    if (badgePortal) return badgePortal;
    badgePortal = document.createElement('div');
    badgePortal.className = 'drift-feed-badge-portal';
    badgePortal.setAttribute('aria-hidden', 'true');
    document.body.appendChild(badgePortal);
    return badgePortal;
  }
  function syncBadgePortal(slide) {
    var stack = slide ? slide.querySelector('.drift-badge-stack') : null;
    var portal = ensureBadgePortal();
    portal.innerHTML = '';
    if (stack) {
      var clone = stack.cloneNode(true);
      clone.style.cssText = '';
      portal.appendChild(clone);
      portal.classList.add('is-visible');
    } else {
      portal.classList.remove('is-visible');
    }
  }

  /* ========================================
     Lookahead image warming
     ========================================
     Only the very first product ships with loading="eager"; every other feed
     image is lazy. That meant the next product started fetching at roughly
     the moment it reached the edge of the viewport, so it visibly popped in
     mid-scroll instead of already being there.

     Warm the two products ahead of the active one, plus the one behind it for
     scrolling back up. Flipping loading to eager starts the fetch, and
     decode() forces the bitmap to be prepared now rather than on the frame it
     becomes visible — decode is the part that actually caused the hitch.

     Only the leading image of an upcoming product is warmed. Its other swipe
     images are warmed when it becomes active, so a shopper who never swipes
     sideways is not made to download three extra photos per product. */
  var LOOKAHEAD = 2;
  var warmedFirst = [];
  var warmedFull = [];

  function warmImage(img) {
    if (!img || img.getAttribute('data-warmed') === '1') return;
    img.setAttribute('data-warmed', '1');
    if (img.getAttribute('loading') !== 'eager') img.setAttribute('loading', 'eager');
    if (typeof img.decode === 'function') {
      /* Rejects for images that are not yet fetchable; harmless either way. */
      try { img.decode().catch(function () {}); } catch (e) {}
    }
  }

  function warmSlideFirst(i) {
    if (i < 0 || i >= slides.length || warmedFirst[i]) return;
    warmedFirst[i] = true;
    warmImage(slides[i].querySelector('.drift-feed__image'));
  }

  function warmSlideFull(i) {
    if (i < 0 || i >= slides.length || warmedFull[i]) return;
    warmedFull[i] = true;
    var imgs = slides[i].querySelectorAll('.drift-feed__image');
    for (var k = 0; k < imgs.length; k++) warmImage(imgs[k]);
  }

  function warmAround(index) {
    warmSlideFull(index);
    for (var n = 1; n <= LOOKAHEAD; n++) warmSlideFirst(index + n);
    warmSlideFirst(index - 1);
  }

  function setActive(index) {
    if (index === currentIndex) return;

    /* Any product scrolled away from goes back to its first image, so a
       half-swiped track doesn't greet the shopper on image 2 next time. */
    resetInactiveTracks(index);
    if (currentIndex >= 0 && currentIndex < slides.length) {
      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
    }
    currentIndex = index;
    slides[currentIndex].classList.add('is-active');
    if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
    if (counterEl) {
      var display = currentIndex + 1;
      counterEl.textContent = slides.length >= 10 && display < 10 ? '0' + display : '' + display;
    }
    applyBgColor(slides[currentIndex]);
    applyBgMedia(slides[currentIndex]);
    applyBgGradient(slides[currentIndex]);
    syncBadgePortal(slides[currentIndex]);
    warmAround(currentIndex);
  }

  function getVisibleIndex() {
    var viewCenter = track.scrollTop + track.offsetHeight * 0.5;
    var closest = 0;
    var minDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var center = slides[i].offsetTop + slides[i].offsetHeight * 0.5;
      var d = Math.abs(center - viewCenter);
      if (d < minDist) { minDist = d; closest = i; }
    }
    return closest;
  }

  function applyTransforms() {
    var trackH = track.offsetHeight;
    var scrollTop = track.scrollTop;
    var viewCenter = scrollTop + trackH * 0.5;

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var slideImgs = slide.querySelectorAll('.drift-feed__image');
      if (!slideImgs.length) continue;
      /* Desktop keeps its original behaviour: only the first image is styled
         here. The second is the hover overlay, and writing an inline opacity
         onto it would override the CSS that keeps it hidden until hover —
         which is exactly how it started showing up unprompted.
         On mobile every image in the track needs the vertical treatment. */
      var isMobileFeed = window.innerWidth < 1025;
      var hTrack = isMobileFeed ? slide.querySelector('.drift-feed__media[data-feed-swipe]') : null;
      /* Inside a swipe track the horizontal pass owns the images, so the
         vertical effect is applied to the track as a whole — otherwise the
         two passes would overwrite each other's inline styles every frame. */
      var vTargets = hTrack ? [hTrack] : (isMobileFeed ? slideImgs : [slideImgs[0]]);

      var slideH = slide.offsetHeight;
      var slideCenter = slide.offsetTop + slideH * 0.5;
      var dist = Math.abs(slideCenter - viewCenter);
      var progress = Math.min(dist / slideH, 1);

      var scale = SCALE_MAX - progress * (SCALE_MAX - SCALE_MIN);
      var blur = progress * BLUR_MAX;
      var opacity = 1 - progress * (1 - OPACITY_MIN);

      if (slide.classList.contains('is-sold-out')) {
        for (var si = 0; si < vTargets.length; si++) {
          vTargets[si].style.transform = 'scale(' + scale + ')';
          vTargets[si].style.filter = 'blur(4px)';
          vTargets[si].style.opacity = 0.35;
        }
        var soldBadge = slide.querySelector('.drift-badge-stack');
        if (soldBadge) soldBadge.style.opacity = 0.35;
        continue;
      }

      for (var sj = 0; sj < vTargets.length; sj++) {
        vTargets[sj].style.transform = 'scale(' + scale + ')';
        vTargets[sj].style.opacity = opacity;
        if (blur > 1) {
          vTargets[sj].style.filter = 'blur(' + blur + 'px)';
        } else {
          vTargets[sj].style.removeProperty('filter');
        }
      }

var badge = slide.querySelector('.drift-badge-stack');
if (badge) badge.style.opacity = opacity;
    }
  }

  /* ========================================
     Horizontal image swipe (mobile)
     ========================================
     Same distance treatment the PDP gallery uses: whichever image is nearest
     the centre of the track is full size and sharp, its neighbours scale
     down, blur and fade. Driven by the track's own scroll position so it
     rides the native scroll-snap rather than replacing it. */

  var H_SCALE_MIN = 0.85;
  var H_BLUR_MAX = 6;
  var H_OPACITY_MIN = 0.35;

  function applyImageTrack(imgTrack) {
    var imgs = imgTrack.querySelectorAll('.drift-feed__image');
    if (imgs.length < 2) return;
    var centre = imgTrack.scrollLeft + imgTrack.clientWidth / 2;
    for (var i = 0; i < imgs.length; i++) {
      var el = imgs[i];
      var elCentre = el.offsetLeft + el.offsetWidth / 2;
      var progress = Math.min(Math.abs(elCentre - centre) / Math.max(imgTrack.clientWidth, 1), 1);
      var hScale = 1 - progress * (1 - H_SCALE_MIN);
      var hBlur = progress * H_BLUR_MAX;
      var hOpacity = 1 - progress * (1 - H_OPACITY_MIN);
      el.style.transform = 'scale(' + hScale.toFixed(3) + ')';
      el.style.opacity = hOpacity.toFixed(3);
      if (hBlur > 1) {
        el.style.filter = 'blur(' + hBlur.toFixed(1) + 'px)';
      } else {
        el.style.removeProperty('filter');
      }
    }
  }

  /* Scroll-snap keeps whatever horizontal position a track was left on, so a
     product the shopper had swiped through would still be showing image 2 the
     next time it came round. Reset any track that isn't the active slide. */
  function resetInactiveTracks(activeIdx) {
    var imgTracks = section.querySelectorAll('.drift-feed__media[data-feed-swipe]');
    Array.prototype.forEach.call(imgTracks, function (imgTrack) {
      var owner = imgTrack.closest('.drift-feed__slide');
      if (!owner) return;
      var idx = parseInt(owner.getAttribute('data-feed-slide'), 10);
      if (idx === activeIdx || imgTrack.scrollLeft === 0) return;
      imgTrack.scrollLeft = 0;
      applyImageTrack(imgTrack);
    });
  }

  function setupImageTracks() {
    if (window.innerWidth >= 1025) return;
    var imgTracks = section.querySelectorAll('.drift-feed__media[data-feed-swipe]');
    Array.prototype.forEach.call(imgTracks, function (imgTrack) {
      if (imgTrack._driftHBound) return;
      imgTrack._driftHBound = true;
      /* Browsers restore the scroll offset of every scroll container on
         reload, so a track the shopper had swiped came back showing its
         second image. Force it home — once now, once after a frame, and
         once more on load, because images finishing decode can resize the
         track and shift the offset again. */
      var home = function () {
        if (imgTrack.scrollLeft !== 0) imgTrack.scrollLeft = 0;
        applyImageTrack(imgTrack);
      };
      home();
      requestAnimationFrame(home);
      window.addEventListener('load', home, { once: true });
      window.addEventListener('pageshow', function (e) { if (e.persisted) home(); });
      var raf = null;
      imgTrack.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          applyImageTrack(imgTrack);
        });
      }, { passive: true });
      applyImageTrack(imgTrack);
    });
  }

  setupImageTracks();
  window.addEventListener('resize', function () { setupImageTracks(); });

  var lastScroll = -1;

  function frameLoop() {
    var st = track.scrollTop;
    if (st !== lastScroll) {
      lastScroll = st;
      applyTransforms();
      setActive(getVisibleIndex());
    }
    requestAnimationFrame(frameLoop);
  }

  var settledOnBoundary = false;
  var settleTimer;

  track.addEventListener('scroll', function () {
    settledOnBoundary = false;
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      if (isLooping) return;
      var maxScroll = track.scrollHeight - track.offsetHeight;
      var atBottom = track.scrollTop >= maxScroll - 2;
      var atTop = track.scrollTop <= 2;
      var idx = getVisibleIndex();
      if ((atBottom && idx === slides.length - 1) || (atTop && idx === 0)) {
        settledOnBoundary = true;
      }
    }, 400);
  }, { passive: true });

  track.addEventListener('wheel', function (e) {
    if (isLooping || !settledOnBoundary) return;
    var maxScroll = track.scrollHeight - track.offsetHeight;
    var atBottom = track.scrollTop >= maxScroll - 2;
    var atTop = track.scrollTop <= 2;
    var idx = getVisibleIndex();
    if (atBottom && idx === slides.length - 1 && e.deltaY > 0) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(0);
      setTimeout(function () { isLooping = false; }, 1000);
    }
    if (atTop && idx === 0 && e.deltaY < 0) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(slides.length - 1);
      setTimeout(function () { isLooping = false; }, 1000);
    }
  }, { passive: true });

  var touchStartY = 0;

  track.addEventListener('touchstart', function (e) {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    if (isLooping || !settledOnBoundary) return;
    var touchEndY = e.changedTouches[0].clientY;
    var diff = touchStartY - touchEndY;
    var maxScroll = track.scrollHeight - track.offsetHeight;
    var atBottom = track.scrollTop >= maxScroll - 2;
    var atTop = track.scrollTop <= 2;
    var idx = getVisibleIndex();
    if (atBottom && idx === slides.length - 1 && diff > 30) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(0);
      setTimeout(function () { isLooping = false; }, 1000);
    }
    if (atTop && idx === 0 && diff < -30) {
      settledOnBoundary = false;
      isLooping = true;
      scrollToIndex(slides.length - 1);
      setTimeout(function () { isLooping = false; }, 1000);
    }
  }, { passive: true });

  function scrollToIndex(index) {
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;
    var slide = slides[index];
    var slideCenter = slide.offsetTop + slide.offsetHeight * 0.5;
    var targetScroll = slideCenter - track.offsetHeight * 0.5;
    setActive(index);
    track.scrollTo({ top: targetScroll, behavior: 'smooth' });
  }

  function forceScrollToFirst() {
    if (!slides.length) return;
    var slide = slides[0];
    var slideCenter = slide.offsetTop + slide.offsetHeight * 0.5;
    var targetScroll = slideCenter - track.offsetHeight * 0.5;
    track.scrollTop = Math.max(0, targetScroll);
  }

  if (spacerTop) {
    spacerTop.addEventListener('click', function () {
      scrollToIndex(currentIndex - 1);
    });
  }

  if (spacerBottom) {
    spacerBottom.addEventListener('click', function () {
      scrollToIndex(currentIndex + 1);
    });
  }

  if (dots.length > 0) {
    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-feed-dot'), 10);
        scrollToIndex(index);
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    var tag = document.activeElement && document.activeElement.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    if (e.key === 'ArrowDown' || e.key === 'j') {
      e.preventDefault();
      scrollToIndex(currentIndex + 1);
    } else if (e.key === 'ArrowUp' || e.key === 'k') {
      e.preventDefault();
      scrollToIndex(currentIndex - 1);
    }
  });

  for (var s = 0; s < slides.length; s++) {
    slides[s].addEventListener('click', function (e) {
      var slideIndex = parseInt(this.getAttribute('data-feed-slide'), 10);
      if (slideIndex === currentIndex) return;
      if (e.target.closest('[data-feed-info]') && e.target.closest('.is-active')) return;
      e.preventDefault();
      scrollToIndex(slideIndex);
    });
  }

  track.addEventListener('dragstart', function (e) { e.preventDefault(); });

  window.addEventListener('resize', function () {
    setPadding();
    applyTransforms();
  });

  track.style.scrollSnapType = 'none';
  setPadding();
  void track.offsetHeight;

  if (hasResume) {
    var resumeSlide = slides[resumeIndex];
    var resumeCenter = resumeSlide.offsetTop + resumeSlide.offsetHeight * 0.5;
    var resumeTarget = resumeCenter - track.offsetHeight * 0.5;
    track.scrollTop = Math.max(0, resumeTarget);
    applyTransforms();
    setActive(resumeIndex);
  } else {
    forceScrollToFirst();
    applyTransforms();
    setActive(0);
  }

  /* Belt-and-suspenders re-apply of the initial slide's bg gradient.
     Handles the race where the WebGL shader is still downloading when
     setActive(0) first calls window.driftSiteBg.override(): override sets
     targetPalette but no visible shader update fires until it loads. By
     the next frame + window.load, both drift-bg-init and shader are
     guaranteed available. */
  if (bgMorphEnabled) {
    requestAnimationFrame(function () {
      if (currentIndex >= 0 && slides[currentIndex]) applyBgGradient(slides[currentIndex]);
    });
    var onLoadReapply = function () {
      if (currentIndex >= 0 && slides[currentIndex]) applyBgGradient(slides[currentIndex]);
    };
    if (document.readyState === 'complete') {
      setTimeout(onLoadReapply, 0);
    } else {
      window.addEventListener('load', onLoadReapply, { once: true });
    }
  }

  requestAnimationFrame(frameLoop);

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      track.style.scrollSnapType = '';
      track.classList.add('is-ready');
    });
  });

  /* ========================================
     FEATURE-002: View toggle (swipe / grid)
     ======================================== */

  /* Mirror drift-collection's setView: swap `hidden` on the two view
     blocks, set [data-view-mode] on html + section (header icons key
     off this), persist the choice. Swipe stays mounted while hidden so
     no re-init is needed. */
  function applyView(view) {
    if (view !== 'swipe' && view !== 'grid') return;
    if (!gridEl) return; // no grid block rendered — can't switch
    if (view === 'swipe') {
      gridEl.hidden = true;
      feed.hidden = false;
      // Track dimensions may have changed while hidden — recompute spacers
      // and dispatch scroll so the swipe transforms snap into place.
      setPadding();
      if (track) {
        track.dispatchEvent(new Event('scroll'));
      }
    } else {
      feed.hidden = true;
      gridEl.hidden = false;
      // Lazy-load grid images on first reveal (mirrors Collection's pattern).
      if (!gridEl._driftImagesLoaded) {
        gridEl._driftImagesLoaded = true;
        var imgs = gridEl.querySelectorAll('.drift-collection__grid-img[data-src]');
        imgs.forEach(function (img) {
          var full = new Image();
          full.onload = function () {
            img.src = img.dataset.src;
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
            img.classList.add('is-loaded');
          };
          full.src = img.dataset.src;
        });
      }
      gridEl.scrollTop = 0;
    }
    section.setAttribute('data-view-mode', view);
    document.documentElement.setAttribute('data-view-mode', view);
    /* Live Gradient: grid view reverts to the neutral theme palette;
       returning to swipe re-applies the active slide's metafield color. */
    if (bgMorphEnabled) {
      if (view === 'grid') {
        if (window.driftSiteBg) window.driftSiteBg.reset();
        feed.style.removeProperty('--drift-feed-bg-active');
        feed.style.removeProperty('--drift-feed-bg-text');
      } else if (currentIndex >= 0 && slides[currentIndex]) {
        applyBgColor(slides[currentIndex]);
        applyBgGradient(slides[currentIndex]);
      }
    }
    try { localStorage.setItem('drift-feed-view', view); } catch (e) {}
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-label', view === 'swipe' ? 'Switch to grid view' : 'Switch to swipe view');
    }
  }

  /* If initial view is grid, run the lazy-load logic up front so the
     blur-up images become real. */
  if (initialView === 'grid' && gridEl && !gridEl._driftImagesLoaded) {
    gridEl._driftImagesLoaded = true;
    var initImgs = gridEl.querySelectorAll('.drift-collection__grid-img[data-src]');
    initImgs.forEach(function (img) {
      var full = new Image();
      full.onload = function () {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.classList.add('is-loaded');
      };
      full.src = img.dataset.src;
    });
  }

  var toggleBtn = document.querySelector('[data-view-toggle]');
  // If a Collection section is on the page, let drift-collection.js own
  // the toggle button — don't double-wire it.
  var hasCollection = !!document.querySelector('[data-section-type="drift-collection"]');

  if (toggleBtn && allowToggle && !hasCollection) {
    toggleBtn.addEventListener('click', function () {
      var current = section.getAttribute('data-view-mode');
      applyView(current === 'grid' ? 'swipe' : 'grid');
    });
    // Initial aria-label reflects what the click will do
    toggleBtn.setAttribute(
      'aria-label',
      initialView === 'swipe' ? 'Switch to grid view' : 'Switch to swipe view'
    );
    // Keyboard shortcut: V to toggle (matches Collection's pattern)
    document.addEventListener('keydown', function (e) {
      var tag = document.activeElement && document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === 'v' || e.key === 'V') {
        e.preventDefault();
        var current = feed.getAttribute('data-feed-layout');
        applyView(current === 'grid' ? 'swipe' : 'grid');
      }
    });
  }
})();